
export enum ExpenseMethod {
  MILEAGE = 3,
  OUT_OF_POCKET = 2,
  CREDIT_CARD = 1,
}
